export default __webpack_public_path__ + "static/media/oscer-pres-sweating.77aaae35.svg";